/**
 * selectors/users.ts
 * desc: selectors for users
 * note:
 */
import { createSelector } from "@reduxjs/toolkit";
import { sortAz } from "../../utilities";
import type { RootState } from '../index';

const selectUsers = (state: RootState) => state.users;
const selectRoles = (state: RootState) => state.roles;
 
export const selectClientUsers = createSelector(selectUsers, (users) => {
    return users.list.filter(user => !user.email?.endsWith('@ymeadows.com'));
});

export const selectCurrentUser = createSelector(selectUsers, (users) => users.me);

export const selectUsersDb = createSelector(selectUsers, (users) => users.listDb);

export const selectAvailableRoles = createSelector(selectUsers, selectRoles, (users, roles) => {
    const result = roles.list;
    if (!users.me?.roles?.includes('ymstaff')) {
        return roles.list.filter(x => x.name !== 'ymstaff');
    }
    return sortAz(result, 'name', { toSorted: true });
});

export const selectIsUserHasPermissions = createSelector(selectCurrentUser, (user) => {
    return (permissions: string[]) => {
        return permissions.some(val => user?.permissions?.includes(val));
    };
});

export const selectUsersIdentityProviders = createSelector(selectUsers, (users) => users.identityProviders);

export const selectUsersIsLoading = createSelector(selectUsers, (users) => users.isLoading);

export const selectUsersDetail = createSelector(selectUsers, (users) => users.detail);

export const selectIsUserYmStaff = createSelector(selectCurrentUser, (user) => {
    return user?.roles?.includes('ymstaff');
});

const ADMIN_ROLES = [ 'ymstaff', 'superadmin', 'admin' ];

export const selectIsUserAdmin = createSelector(selectCurrentUser, (user) => {
    return ADMIN_ROLES.some(role => user?.roles?.includes(role));
});
